export default __webpack_public_path__ + "static/media/googlePlay-de.c7dc723f.svg";